// Candidate model options the routing layer can select.
// Synthetic — costs and latencies are illustrative only.
// quality is 0-100. risk_handling is 0-100 (higher = better at high-sensitivity/refusal handling).

export const MODEL_CATALOG = [
  {
    id: "fast-mini",
    label: "Fast Mini",
    family: "Lightweight",
    cost_per_1k: 0.0008,
    latency_ms: 220,
    quality: 64,
    risk_handling: 40,
    note: "Cheapest path. Good for low-stakes drafting and routine summarisation.",
  },
  {
    id: "balanced",
    label: "Balanced Standard",
    family: "Mid-tier",
    cost_per_1k: 0.0046,
    latency_ms: 540,
    quality: 81,
    risk_handling: 65,
    note: "Workhorse. Suitable for most operational requests.",
  },
  {
    id: "premium-reasoning",
    label: "Premium Reasoning",
    family: "Frontier",
    cost_per_1k: 0.0182,
    latency_ms: 1180,
    quality: 94,
    risk_handling: 78,
    note: "Higher quality and structured reasoning. Slower and costlier.",
  },
  {
    id: "governed-safer",
    label: "Governed-Safer",
    family: "Constrained · Risk-aware",
    cost_per_1k: 0.0094,
    latency_ms: 720,
    quality: 86,
    risk_handling: 96,
    note: "Risk-aware route with tighter refusal calibration. Preferred for sensitive content.",
  },
];

export const COMPARE_MODES = [
  { id: "auto", label: "Auto" },
  { id: "cheap", label: "Cheap" },
  { id: "premium", label: "Premium" },
  { id: "governed", label: "Governed" },
];
